<template>
  <div :class="{ 'title-bar': true, ...shadow }">
    <div class="layout wrap px-4 py-3 align-center">
      <div class="title layout">
        <slot name="left" />
      </div>
      <v-spacer />
      <div class="infos">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleComponent',
  props: ['offset'],
  computed: {
    shadow() {
      return {
        'elevation-2': this.offset,
        white: this.offset
      };
    }
  }
};
</script>

<style scoped>
.title-bar {
  /* background-color: rgba(255,255, 255,.7) !important; */
  /* border-bottom: 1px solid rgba(0,0,0,.12); */
  max-height: 53px !important;
  align-items: center;
  position: relative;
  z-index: 200;
  transition: all 500ms ease;
}

.white {
  background-color: rgba(255, 255, 255, 1) !important;
}
.title {
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--charcoal);
}
</style>
